import React from 'react'
import moment from 'moment'
import CircularProgress from 'material-ui/CircularProgress'
import FileDownloadIcon from 'material-ui/svg-icons/file/file-download'
import FlatButton from 'material-ui/FlatButton'
import LinearProgress from 'material-ui/LinearProgress'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import api from '../../api'

class ExportsPage extends React.Component<any, any> {
  constructor () {
    super()
    this.state = {
      exports: [],
      loading: true,
      refreshTimer: null
    }
  }

  componentDidMount () {
    this.fetchExports()
  }

  componentWillUnmount () {
    this.stopRefreshTimer()
  }

  startRefreshTimer () {
    // Only start a timer if one doesn't already exist
    if (!this.state.refreshTimer) {
      const timer = setInterval(() => {
        this.fetchExports()
      }, 2000)
      this.setState({ refreshTimer: timer })
    }
  }

  stopRefreshTimer () {
    // Clear the interval if it exists
    if (this.state.refreshTimer) {
      clearInterval(this.state.refreshTimer)
      this.setState({ refreshTimer: null })
    }
  }

  hasPendingExports (exports) {
    return exports.some(exp =>
      exp.status === 'pending' || exp.status === 'processing'
    )
  }

  fetchExports () {
    this.setState({ loading: true })

    api.get('admin/exports')
      .then(res => res.json())
      .then(exports => {
        this.setState({
          exports,
          loading: false
        })

        // Check if we have any pending exports
        if (this.hasPendingExports(exports)) {
          // Start the refresh timer if we have pending exports
          this.startRefreshTimer()
        } else {
          // Stop the refresh timer if no pending exports
          this.stopRefreshTimer()
        }
      })
      .catch(err => {
        console.error('Failed to fetch exports:', err)
        this.setState({ loading: false })
      })
  }

  renderStatus (status, progress) {
    switch (status) {
      case 'pending':
        return (
          <div>
            <div>Queued</div>
            <LinearProgress mode='indeterminate' />
          </div>
        )
      case 'processing':
        return (
          <div>
            <div>Processing ({Math.round(progress)}%)</div>
            <LinearProgress mode='determinate' value={progress} />
          </div>
        )
      case 'completed':
        return <div style={{ color: 'green' }}>Completed</div>
      case 'failed':
        return <div style={{ color: 'red' }}>Failed</div>
      default:
        return <div>{status}</div>
    }
  }

  renderActions (exp) {
    if (exp.status === 'completed') {
      return (
        <div>
          <FlatButton
            target='_blank'
            secondary
            href={exp.file_url}
            icon={<FileDownloadIcon />}
            label='Download'
            style={{ marginRight: 8 }}
          />
        </div>
      )
    } else if (exp.status === 'failed') {
      return (
        <div>
          <div style={{ color: 'red', marginBottom: 8 }}>
            Error: {exp.error_message}
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  render () {
    const { exports, loading } = this.state

    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: 20 }}>
          <CircularProgress size={60} thickness={5} />
          <div>Loading exports...</div>
        </div>
      )
    }

    return (
      <div>
        <p>Your generated exports will be available for up to 1 hour</p>

        {exports.length === 0 ? (
          <div style={{ padding: 20, textAlign: 'center' }}>
            No exports found. Go to the Reports page to generate new exports.
          </div>
        ) : (
          <Table>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn>Name</TableHeaderColumn>
                <TableHeaderColumn>Status</TableHeaderColumn>
                <TableHeaderColumn>Created</TableHeaderColumn>
                <TableHeaderColumn>Completed</TableHeaderColumn>
                <TableHeaderColumn>Expires</TableHeaderColumn>
                <TableHeaderColumn>Actions</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {exports.map(exp => (
                <TableRow key={exp.id} selectable={false}>
                  <TableRowColumn>{exp.name}</TableRowColumn>
                  <TableRowColumn>{this.renderStatus(exp.status, exp.progress)}</TableRowColumn>
                  <TableRowColumn>{moment(exp.created_at).format('MMM D, YYYY h:mm A')}</TableRowColumn>
                  <TableRowColumn>
                    {exp.completed_at
                      ? moment(exp.completed_at).format('MMM D, YYYY h:mm A')
                      : '-'}
                  </TableRowColumn>
                  <TableRowColumn>
                    {exp.expires_at
                      ? moment(exp.expires_at).format('MMM D, YYYY h:mm A')
                      : '-'}
                  </TableRowColumn>
                  <TableRowColumn>{this.renderActions(exp)}</TableRowColumn>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    )
  }
}

export default ExportsPage
